/**
 * The one backdrop every modal/overlay shares — Dialog, Sheet, Drawer, AlertDialog.
 *
 * The darkness, the blur and the grain are driven by the `--overlay-backdrop` / `--overlay-blur` / `--overlay-noise` CSS variables
 * (defined per theme in `styles/foundation.css`), so the scrim is tuned in a SINGLE place and stays consistent
 * across every overlay and both themes. Components add only their own positioning/animation classes on top.
 */
export const overlayScrimClassName =
  "bg-[var(--overlay-backdrop)] [background-image:var(--overlay-noise)] supports-backdrop-filter:backdrop-blur-[var(--overlay-blur)]"
